var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"drawImage",staticClass:"z-draw-image"},[(_vm.base64)?_c('div',{ref:"drawing",staticClass:"drawing",style:({ 
      width: `${ _vm.dynamicSize }px`,
      height: `${ _vm.dynamicSize }px`
    })},[_c('div',{staticClass:"rotate",style:({ 
        width: `${ _vm.rotatedWidth }px`,
        height: `${ _vm.rotatedHeight }px`
      }),attrs:{"id":"rotate"}},[_c('canvas',{ref:"drewCanvas",staticClass:"drewCanvas"}),_c('canvas',{ref:"drawingCanvas",staticClass:"drawingCanvas"})])]):_c('div',{staticClass:"load-failed"},[_vm._v(" 未加载到图片 ")]),_c('v-overlay',{attrs:{"absolute":true,"opacity":.8,"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }